export interface Init {
  debug: boolean;
}

export interface LoadResources {
  language: string;
}

export interface AddResources {
  name: string;
  type: 'vertical';
}

export type Namespaces = readonly string[];

export enum Status {
  uninitialized,
  initialized,
  failed,
}
